// src/components/chat/TipsIcon.tsx

import * as React from "react";

interface TipsIconProps {
  /** Icon size in pixels */
  size?: number;
  /** Icon color */
  color?: string;
  /** Additional CSS class */
  className?: string;
}

/**
 * Animated lightbulb icon with twinkling stars for learning tips.
 * Used in ThinkingSection to visually distinguish tips from thinking words.
 */
const TipsIcon: React.FC<TipsIconProps> = ({ size = 24, color = "#0066cc", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill={color}
    className={className}
    style={{ flexShrink: 0 }}
  >
    <style>
      {`
        @keyframes twinkle1 {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.3; transform: scale(0.6); }
        }
        @keyframes twinkle2 {
          0%, 100% { opacity: 0.3; transform: scale(0.6); }
          50% { opacity: 1; transform: scale(1); }
        }
        .tips-star-1 { animation: twinkle1 1.2s ease-in-out infinite; transform-origin: 19px 2.5px; }
        .tips-star-2 { animation: twinkle2 1.2s ease-in-out infinite; transform-origin: 23px 7px; }
        .tips-star-3 { animation: twinkle1 1.5s ease-in-out infinite 0.3s; transform-origin: 19.5px 8.5px; }
      `}
    </style>

    {/* Lightbulb */}
    <path d="M7 20h4c0 1.1-.9 2-2 2s-2-.9-2-2zm-2-1h8v-2H5v2zm11.5-9.5c0 3.82-2.66 5.86-3.77 6.5H5.27c-1.11-.64-3.77-2.68-3.77-6.5C1.5 5.36 4.86 2 9 2s7.5 3.36 7.5 7.5z" />

    {/* Twinkling stars */}
    <path className="tips-star-1" d="M19 0l.5 1 1 .5-1 .5-.5 1-.5-1-1-.5 1-.5z" />
    <path className="tips-star-2" d="M23 5l.5 1 1 .5-1 .5-.5 1-.5-1-1-.5 1-.5z" />
    <path className="tips-star-3" d="M19.5 7l.35.75.75.35-.75.35-.35.75-.35-.75-.75-.35.75-.35z" />
  </svg>
);

export default TipsIcon;
